module.exports = __webpack_public_path__ + "static/38d6edd1be03c943b94f6c92baf873dc3612024568a016da810eec6c54cdb177-e75efa774d7092f499d2619707b12e99.jpeg";